import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import FormSH from '../../../../../library/form/components/FormSH';
import FormInput from '../../../../../library/form/components/FormInput';
import * as fn from "../../../../../helper/uiFunctions";

const ProdMatrixRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    // console.log("Matrix data ProdMatrixRow", viewData);

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <ul className="uiDPEditLine">
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn200" rowKey={rowKey} 
                    action={{ paramName: "variation1" }} >
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput"
                        action={{
                            InputType: "ac", paramName: "variation1", acMethod: "CategoryDetail",
                            actionId:"refresh",
                            actionParam: { actionType: "updateMatrixDetail" }, acDepCtrl: { 'dparam': '%dataList.valLCat'}
                        }}
                    />
                    <FormSH formObject={formObject} rowKey=""
                        action={{ actionId: "new", paramName: "variation1",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                    </FormSH>
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn200" rowKey={rowKey}
                        action={{ paramName: "variation2" }} >
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput"
                        action={{
                            InputType: "ac", paramName: "variation2", acMethod: "CategoryDetail",
                            actionId:"refresh",
                            actionParam: { actionType: "updateMatrixDetail" }, acDepCtrl: { 'dparam': '%dataList.valLCat'}
                        }}
                    />
                    <FormSH formObject={formObject} rowKey=""
                        action={{ actionId: "new", paramName: "variation2",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                    </FormSH>
                </FormWrapper>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" 
                        action={{ InputType: "input", paramName: "quantity1", actionId:"refresh", actionParam: {actionType: "updateMatrixDetail"} }} />
                </li>
                <li className="uiColumnCenter" style={{ width: '330px' }}>
                    <FormInput formObject={formObject} rowKey={rowKey}
                        action={{
                            InputType: "ac", paramName: "bomName", acMethod: "TargetItemBom",
                            actionId:"refresh",
                            acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdtId': '%dataList.tdtId', 'tdId': '%dataList.tdId' },
                            actionParam: { actionType: "updateMatrixDetail" }
                        }} className='uiInput uiSpacerH10' style={{ width: '300px' }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormButton formObject={formObject} rowKey={rowKey} 
                        starIcon="confirm"
                        onlyIcon={true}
                        tooltip="Confirm Changes"
                        starIconClassName="uiColorNeutralAction"
                        className="" 
                        action={{ actionId: "save",  actionParam: {}, containerKey: "row" }}
                    ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey} 
                        starIcon="cancel"
                        onlyIcon={true}
                        tooltip="Cancel Changes"
                        starIconClassName="uiColorNegativeAction"
                        className="" 
                        action={{ actionId: "cancel",  actionParam: {}, refreshMode:"dep", containerKey: "row" }}
                    ></FormButton>
                </li>
            </ul>
        )
    }
    else {
        return (
            <ul className="uiDPEditLine">
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn200" rowKey={rowKey} 
                        action={{ paramName: "variation1" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn200" rowKey={rowKey} 
                        action={{ paramName: "variation2" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "quantity" }} />
                </li>
                <li className="uiColumnCenter" style={{ width: '330px' }}>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "bomName" }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormButton formObject={formObject} rowKey={rowKey} 
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        className="" 
                        action={{ actionId: "edit", actionParam: {}, containerKey: "row" }}
                    />
                    <FormButton formObject={formObject} rowKey={rowKey} 
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        className=""
                        action={{ actionId: "del", actionParam: {}, containerKey: "row" }}
                    />
                </li>
            </ul>
        )
    }


}

export default ProdMatrixRow
